import * as React from "react";
import Typography from "@mui/material/Typography";
import Title from "./Title";

/**
 * Deposits component for displaying total credits used in a given time period
 *
 * @param {number} totalCredits - The total credits used
 * @param {Date} minDate - The start date of the period
 * @param {Date} maxDate - The end date of the period
 * @returns {JSX.Element} - The rendered deposits component
 */
export default function Deposits({ totalCredits, minDate, maxDate }) {
  // Calculate the credit value in Rupees
  const creditValueInRupees = totalCredits * 500;

  // Format dates for display
  const formatDate = (date) => {
    if (!date) return "N/A";
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // Determine the title based on date range
  const getTimeframeTitle = () => {
    if (!minDate || !maxDate) return "Total Credits Used";

    // Same month and year
    if (
      minDate.getMonth() === maxDate.getMonth() &&
      minDate.getFullYear() === maxDate.getFullYear()
    ) {
      return `Credits Used (${minDate.toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
      })})`;
    }

    return "Credits Used (Selected Period)";
  };

  return (
    <React.Fragment>
      <Title>{getTimeframeTitle()}</Title>
      <Typography
        component='p'
        variant='h4'
      >
        {totalCredits.toLocaleString()}
      </Typography>
      <Typography
        color='text.secondary'
        sx={{ flex: 1 }}
      >
        ₹{creditValueInRupees.toLocaleString()}
      </Typography>
      <div>
        <Typography
          color='text.secondary'
          sx={{ flex: 1, mt: 1 }}
        >
          {formatDate(minDate)} - {formatDate(maxDate)}
        </Typography>
      </div>
    </React.Fragment>
  );
}
